import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
    $('.vertical-menu').css('background-color', environment.schoolConfig.colorcode)
  }

  closeSidebar() {
    $('body').addClass('sidebar-enable vertical-collpsed');
  }

}
